import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import clientService from '../../services/ClientService';
import { useDispatch } from 'react-redux';



export const initialState = {
	loading: false,
	message: '',
	list:null,
}



export const breakdownlogListAll = createAsyncThunk('breakdownlog/list',async (data, { rejectWithValue }) => {
	
	
	try {
		const response = await clientService.getBreakDownLog(data)
		
        return response.data;
		
		
	} catch (err) {
		
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})


export const breakdownlogListSlice = createSlice({
	name: 'breakdownlog',
	initialState,
	reducers: {
			
		breakdownlogList: (state, action) => {
			state.loading = true
			state.list = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(breakdownlogListAll.pending, (state) => {
                
				state.loading = false
			})
			.addCase(breakdownlogListAll.fulfilled, (state, action) => {
				
                state.loading = true
				state.list = action.payload
			})
			
	},
})

export const { 
	breakdownlogList,
    
    
} = breakdownlogListSlice.actions

export default breakdownlogListSlice.reducer